import React, { useState } from "react";
import { useEffect } from "react";
import { Table as AntTable, Button, Col, Form, Input, message, notification,Modal, Popconfirm, Row, Switch , Tag } from "antd";
import CustomerRequest from "./CustomerRequest";
import Table, { ColumnsType } from "antd/es/table";
import { Link, useNavigate } from "react-router-dom";
import { components, getRowClassName } from "../../utils/utils";
import IMAGES from "../../const/Image";
import Search from "antd/es/input/Search";
import { CustomersFilter } from "./CustomersFilter";
import { FaSliders } from "react-icons/fa6";
import { Space, Tooltip } from "antd";
import {SearchOutlined} from '@ant-design/icons';
import dayjs from "dayjs";
import { usePermission } from "../../hooks/usePermission";
const initialFilter = {
  page: 1
};


// const confirm = (e) => {
//   console.log(e);
//   message.success('Deleted!');
// };

const Customers = () => {

    const hasListPermission = usePermission("Customers", "List");
    // console.log('Has list permission:', hasListPermission);
    // const hasAddPermission = usePermission("Customers", "Add");
    // const hasEditPermission = usePermission("Customers", "Edit");
    // const hasDeletePermission = usePermission("Customers", "Delete");

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const showConfirm = Modal.confirm;
  const [loading, setLoading] = useState(false);
  const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);


  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const fetchCustomerList = () => {
    setLoading(true);
    CustomerRequest.customerList(filter)
      .then((response) => {
        const rawData = response?.data?.data?.data || [];
        console.log(rawData, 'data');
        setLabList(rawData);
        setFilteredCustomers(rawData);
        setTotalRecords(response?.data?.data?.totalItems || rawData.length);
      })
      .catch((error) => {
        // message.error("Failed to fetch customers.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  
  useEffect(() => {
 if (hasListPermission) {
      fetchCustomerList();
    }
  }, [filter , hasListPermission]);



  const handleFilter = (value) => {
    setFilter({ ...filter, ...filterForm, ...initialFilter })
    console.log('filter', filter)
    setIsModalOpen(false)
  }

  const handleStatusChange = (checked, item) => {
    showConfirm({
      title: `Are you sure you want to ${checked ? "activate" : "deactivate"} this customer?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setLoading(true);
        CustomerRequest.update({
          status: checked,
          id: item.id,
        })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: "Status updated successfully",
              });
              setLabList((prevList) =>
                prevList.map((el) =>
                  el.id === item.id ? { ...el, is_active: checked ? 1 : 0 } : el
                )
              );
              fetchCustomerList();
            } else {
              notification.error({
                message: "Failed to update status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };

  const columns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
      // width:'60px'
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      // width:'300px'
      // ellipsis: true
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      // width:'300px'
      // ellipsis: true
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      width: 100,
      render: (gender) => (
        gender === 0 ? "Male" : gender === 1 ? "Female" : "Unisex"
      )
    },
    // {
    //   title: "Address",
    //   dataIndex: "userAddress",
    //   key: "userAddress",
    //   render: (userAddress) =>
    //     userAddress ? `${userAddress.city}, ${userAddress.state}` : "",
    // },
    // {
    //   title: "Password",
    //   dataIndex: "password",
    //   key: "password",
    // },
    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      // render: (is_active, item) => (
      //   <Switch
      //     checked={is_active === 1}
      //     checkedChildren="Active"
      //     unCheckedChildren="Inactive"
  
      //   />
      // ),
      render: (is_active) => (
        <Tag color={is_active === 1 ? "green" : "red"}>
          {is_active === 1 ? "Active" : "Inactive"}
        </Tag>
      ),
    },
   
   
    {
      title: "Email Verified",
      dataIndex: "isEmailVerified",
      key: "isEmailVerified",
      render: (isEmailVerified) => (
        isEmailVerified === 0 ? "No" : "Yes"
      )
    },
    {
      title: "Registration Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => createdAt ? dayjs(createdAt).format("DD-MM-YYYY") : "-",
    },
    {
      title: "View Details",
      dataIndex: "action",
      align: 'center',
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip
            title="View Details"
            style={{ color: "red", cursor: "pointer" }}
          >
            <span className="action-icon-bg" onClick={() => navigate(`/customers/details/${record.userId}`)}>
              <img src={IMAGES.ViewIcon} />
            </span>
          </Tooltip>
        </Space>
      ),
    },
    // Add other columns as needed
  ];



  const handleChange = (pagination) => {
    setFilter((prev) => ({
      ...prev,
      page: pagination.current, // Update current page from pagination event
    }));
  };

  const resetFilters = () => {
    form.resetFields();
    setFilterForm({});
    setFilter(initialFilter);
  };


  return (

    <>
      <div className="subscription-hea">
        <Row gutter={[8, 8]} justify="space-between" align="middle" style={{ marginBottom: "2rem" }}>
          <Col>
            <h1 className="app-heading-med">Customers List</h1>
          </Col>
          <Col style={{ gap: "5px" }}>
            <div style={{ display: "flex", gap: "1rem" }}>
              <Input
                placeholder="Search by name"
                size="large"
                className="FilterSearchBox"
                onChange={(e) => setFilterForm({ ...filterForm, search: e.target.value })}
                value={filterForm?.search}
                style={{ width: "100%" }}
                  onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleFilter();
                }
              }}
           
              />
              <Button
                   onClick={handleFilter}
                type="primary"
                htmlType="submit"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <SearchOutlined />
              </Button>
              <Button
                onClick={() => showModal()}
                type="primary"
                htmlType="submit"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <FaSliders />
              </Button>
              <Button

                type="primary"
                className="addcity-btn"
                onClick={resetFilters}
                style={{ height: "39px" }}
              >
                Reset
              </Button>
            </div>

          </Col>
        </Row>
        {/* <Row>
          <Search
            placeholder="Search..."
            allowClear
            size="large"
            enterButton="Search"
            className="FilterSearchBox"
            onSearch={onSearch}
            style={{ width: "30%", marginBottom: "20px" }}
          />
        </Row> */}
      </div>
      {/* <div>
        <Table
          size="middle"
          width="auto"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns(navigate)}
          loading={loading}
          onChange={handleChange}
          dataSource={filteredCustomers}
          pagination={{
            total: totalRecords,
            current: filter?.page || 0,
            defaultCurrent: 1 ,
            onChange: (page) => setFilter({ ...filter, page }),
          }}

     
  
        />
      </div> */}


<Table
  size="middle"
 
  bordered
  rowClassName={getRowClassName}
  components={components}
  columns={columns(navigate)}
  loading={loading}
  dataSource={filteredCustomers}
  onChange={handleChange}
  pagination={{
    total: totalRecords,  // Total items from API
    current: filter?.page,  // Current page from API
    pageSize: 10,  // Keep it fixed to 10 as per API request
    showSizeChanger: false, // Disable changing page size
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    onChange: (page) => setFilter((prev) => ({ ...prev, page })), // Ensure correct page change
  }}
    scroll={{ x: "max-content" }}
/>

      <CustomersFilter handleFilter={handleFilter} form={form} filterForm={filterForm} setFilterForm={setFilterForm} isModalOpen={isModalOpen} handleCancel={handleCancel} />
    </>
  );
};

export default Customers;
